import { render, staticRenderFns } from "./BestsellersList.vue?vue&type=template&id=2001a478&"
import script from "./BestsellersList.vue?vue&type=script&lang=js&"
export * from "./BestsellersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports